module.exports = __webpack_public_path__ + "img/cards-light.73434c90.svg";